module.exports = __webpack_public_path__ + "img/italian-salad-1.2bd28d5b.jpg";